import type { ItineraryImportErrorCode } from '@/models/itineraryImportTypes';
import { IMPORT_PDF_MAX_PAGES } from '@/models/itineraryImportTypes';

const COPY: Partial<Record<ItineraryImportErrorCode, string>> = {
  INSUFFICIENT_TEXT:
    'We couldn’t read enough text from this file. Scanned or image-only PDFs need pasted text, or try a .docx export.',
  INVALID_FILE:
    `This file couldn’t be processed. Check that it’s a valid PDF or Word document under 20 MB and ${IMPORT_PDF_MAX_PAGES} pages.`,
  TEXT_TOO_LONG: 'This content is too long to import. Shorten the text or split it into smaller imports.',
  EXTRACTION_FAILED: 'We couldn’t extract text from this file. Try pasting the content instead.',
  RATE_LIMITED: 'Import limit reached. You can run up to 30 new imports per hour; try again later.',
  UPSTREAM_FAILED: 'Import is temporarily unavailable. Please try again in a moment.',
  NO_PLACES_FOUND: 'No places found in your content. Add city names or more detail and try again.',
  INVALID_SOURCE: 'This import request wasn’t valid. Refresh and try again.',
};

export function userMessageForItineraryImportCode(
  code: ItineraryImportErrorCode,
  serverMessage?: string,
): string {
  if (code === 'INTERNAL_ERROR') {
    return serverMessage?.trim() || 'Something went wrong while importing. Please try again.';
  }
  return COPY[code] ?? serverMessage?.trim() ?? COPY.UPSTREAM_FAILED ?? 'Import failed.';
}
